import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { isEtaArrived, Order } from '~lmo/models/order.model';
import { LmoOrdersService } from '~lmo/services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-orders-complete-dialog',
  styleUrls: ['./lmo-orders-complete-dialog.component.scss'],
  templateUrl: './lmo-orders-complete-dialog.component.html',
})
export class LmoOrdersCompleteDialogComponent implements OnInit {
  private completing$$ = new BehaviorSubject<boolean>(false);
  public isEtaArrived = isEtaArrived;
  public currentOrder$: Observable<Order>;
  public seenRecently$: Observable<boolean>;
  constructor(private orderService: LmoOrdersService, private router: Router, private activatedRoute: ActivatedRoute) {}

  public ngOnInit() {
    this.currentOrder$ = this.orderService.currentOrder$;
    this.seenRecently$ = this.currentOrder$.pipe(
      filter((order) => !!order),
      map((order) => {
        if (!order.user || !order.user.userStatus || !order.user.userStatus.lastTimeSeen) {
          return false;
        }
        const fifteenMinutesAgo = moment().subtract(15, 'minutes');
        const lastTimeSeen = moment(order.user.userStatus.lastTimeSeen);
        return lastTimeSeen.isAfter(fifteenMinutesAgo);
      }),
    );
  }

  public complete() {
    this.completing$$.next(true);
    this.currentOrder$
      .pipe(
        take(1),
        switchMap((order) => this.orderService.completeOrders$(order.id)),
      )
      .subscribe((cancelled) => {
        this.completing$$.next(false);

        if (cancelled) {
          this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {} });
        }
      });
  }
}
